import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WPBService {
  private _wpbRecord: BehaviorSubject<any> = new BehaviorSubject(null);

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for data
   */

  get wpbRecord$(): Observable<any> {
    return this._wpbRecord.asObservable();
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  getWpbRecords(params: any): Observable<any> {
    const url = composeUrl(
      '/v1/Wpb/GetWpbList',
      params
    );

    return this._httpClient.get<any>(url);
  }

  getWpbRecord(wpbId): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/Wpb/GetWpbList/${wpbId}`).pipe(
      tap((response: any) => {
        this._wpbRecord.next(response);
      }),
    );
  }

  createUpdateWpb(payload) {
    return this._httpClient.post<any>(`${environment.apiURL}/${environment.apiVersion}/Wpb/CreateUpdateWpb`, payload).pipe(
      tap((response: any) => {
        return response
      }),
    );
  }

  downloadWpbRecords() {
    return this._httpClient.get(`${environment.apiURL}/${environment.apiVersion}/Wpb/DownloadOverallWpbExcel`, {
      responseType: 'blob',
    }).pipe(
      tap((response: any) => {
        return response
      }),
    );
  }
}
